import axios from 'axios'
import moment, { now } from 'moment'
import Utils from '../../utils/utils'

import config from '../../config'
import CONST from '../../utils/const'
import store from '../../store'

async function elaticsearchQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<plate-*>/_search`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/json'
      }
    }
  )
  return result
}

async function elaticsearchMutiQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<plate-*>/_msearch`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/x-ndjson'
      }
    }
  )
  return result
}

export async function getMutiVehiclePlateAmounts(conditions = [{ unit: 'h', value: 1 }, { unit: 'd', value: 10 }]) {
  const querys = Object.values(conditions) // condition 可能有多個條件   [{ unit: 'd', value: 1 }, { unit: 'd', value: 10 }]
    .map(condition => {
      return `{}\n${JSON.stringify(
        analyticsQuery(condition)
      )}\n`
    })
    .join('')

  const result = await elaticsearchMutiQuery(querys)

  return handleAggsData(result, conditions)
}

function analyticsQuery(condition = {}) {
  const queryTimeUnit = Utils.isEmptyString(condition.unit) ? 'h' : condition.unit
  const queryTime = Utils.isEmptyObject(condition.value) ? 1 : condition.value

  const now = moment()

  return {
    query: {
      range: {
        '@timestamp': {
          gte: moment().subtract(queryTime, queryTimeUnit).valueOf(),
          lte: now.valueOf(),
          format: 'epoch_millis'
        }
      }
    },
    sort: {
      '@timestamp': {
        order: 'desc'
      }
    },
    size: 1,
    aggs: {
      data: {
        terms: {
          field: 'ObjectType.keyword',
          size: CONST.ELK_SEARCH_MAX_SIZE,
          min_doc_count: 0
        },
        aggs: {
          data: {
            terms: {
              field: 'StreamID.keyword',
              size: CONST.ELK_SEARCH_MAX_SIZE,
              min_doc_count: 0
            }
          }
        }
      }
    }
  }
}

function handleAggsData(ESResult, conditions) {
  const responses = ESResult.data.responses
  const timeUnitData = {}
  const objectType = []

  for (let i = 0; i < conditions.length; i++) {
    timeUnitData[conditions[i].value + conditions[i].unit] = []
  }

  for (let i = 0; i < responses.length; i++) {
    const typeBuckets = responses[i].aggregations.data.buckets
    const streamingIdSortData = []

    for (let j = 0; j < typeBuckets.length; j++) {
      objectType.push(typeBuckets[j].key)
      const countBuckets = typeBuckets[j].data.buckets

      for (let k = 0; k < countBuckets.length; k++) {
        const data = {}
        data.streamId = countBuckets[k].key
        data.count = countBuckets[k].doc_count
        streamingIdSortData.push(data)
      }

      const key = Object.keys(timeUnitData)[i]
      timeUnitData[key] = streamingIdSortData
    }
  }

  const result = {
    objectType: [...new Set(objectType.sort())],
    timeUnitData: timeUnitData
  }

  return result
}

export async function getVehiclePlate(condition = {}) {
  if (Utils.isEmptyObject(condition)) {
    return []
  }

  const streamIds = Utils.isEmptyObject(condition.streamIds) ? [] : condition.streamIds
  const queryTimeUnit = Utils.isEmptyString(condition.unit) ? 'd' : condition.unit
  const queryTime = Utils.isEmptyObject(condition.value) ? -1 : condition.value
  const startTime = Utils.isEmptyObject(condition.startTime) ? undefined : condition.startTime
  const endTime = Utils.isEmptyObject(condition.endTime) ? undefined : condition.endTime
  const objectTypes = Utils.isEmptyObject(condition.objectTypes) ? [] : condition.objectTypes
  const keyword = Utils.isEmptyObject(condition.keyword) ? '' : condition.keyword

  // const queryStreamingIds = streamIds.map(sid => `StreamID:"${sid}"`).join(' OR ')
  const lte = endTime ? moment(endTime) : moment()
  const gte = startTime ? moment(startTime) : moment().subtract(queryTime, queryTimeUnit) // 萬一沒有起訖時間則搜尋一天前

  const query = {
    query: {
      bool: {
        filter: [
          {
            range: { // https://discuss.elastic.co/t/multiple-range-filters-for-same-field/73898/2
              '@timestamp': {
                gte: gte.valueOf(),
                lte: lte.valueOf(),
                format: 'epoch_millis'
              }
            }
          },
        ],
        must: []
      }
    },
    sort: {
      '@timestamp': {
        order: 'desc'
      }
    },
    size: CONST.ELK_SEARCH_MAX_SIZE
  }

  // ------filter MessageInOut: in為方向正確
  const queryMessageInOut = {
    query_string: {
      query: '(in)',
      fields: ['Message']
    }
  }
  query.query.bool.filter.push(queryMessageInOut)

  // ------filter stream id
  if(!Utils.isEmptyObject(streamIds)) {
    const streamIdString = Utils.getESQueryStreamingId(streamIds)
    const queryStreamingIds = {
      query_string: {
        analyze_wildcard: true,
        query: streamIdString
      }
    }
    query.query.bool.filter.push(queryStreamingIds)
  }
  

  // ------filter object Type
  const typeString = Utils.getESQueryByObjectType(objectTypes)
  if (!Utils.isEmptyString(typeString)) {
    const queryType = {
      query_string: {
        query: typeString,
        fields: ['ObjectType']
      }
    }
    query.query.bool.filter.push(queryType)
  }

  // -----filter key word on vehicle plate
  if (!Utils.isEmptyString(keyword)) {
    const queryKeyWord = {
      query_string: {
        analyze_wildcard: true,
        query: `*${keyword}*`,
        default_field: 'licence_plate'
      }
    }

    query.query.bool.filter.push(queryKeyWord)
  }

  const result = await elaticsearchQuery(query)
  return Utils.isEmptyObject(result)? [] : result.data.hits.hits
}

export async function getCountPerHour(condition = {}) {
  const streamingIds = Utils.isEmptyObject(condition.streamingIds) ? [] : condition.streamingIds
  const interval = Utils.isEmptyObject(condition.interval) ? '1d' : condition.interval
  // const dataType = Utils.isEmptyObject(condition.dataType) ? CONST.TYPE_OBJECT_DETECTION : condition.dataType
  const startTime = Utils.isEmptyObject(condition.startTime) ? undefined : condition.startTime
  const endTime = Utils.isEmptyObject(condition.endTime) ? undefined : condition.endTime
  const objectTypes = Utils.isEmptyObject(condition.objectTypes) ? [] : condition.objectTypes

  const queryStreamId = Utils.getESQueryStreamingId(streamingIds)
  const intervalUnit = interval.split('')[interval.length - 1]
  const intervalValue = Number(interval.replace(intervalUnit, ''))

  let offset = '+0m'
  // if ((intervalValue > 1 && intervalUnit === 'm') || intervalUnit === 'h') {
  //   const st = moment(startTime).startOf('h')
  //   const diffTime = moment.duration(moment(startTime).diff(st)).as('m')
  //   const modNum = diffTime % intervalValue
  //   offset = `+${modNum}m`
  //   if (intervalUnit === 'h' || intervalValue > 30) {
  //     offset = `+${st.hours() * 60 + modNum}m`
  //   }
  // }
  // if (intervalUnit === 'd') {
  //   offset = '+0h'
  // }

  const query = {
    query: {
      bool: {
        filter: [
          {
            range: {
              '@timestamp': {
                gte: startTime.valueOf(),
                lte: endTime.valueOf(),
                format: 'epoch_millis'
              }
            }
          },
          {
            query_string: {
              analyze_wildcard: true,
              query: queryStreamId
            }
          }
        ]
      }
    },
    size: 1,
    aggs: {
      data: {
        date_histogram: {
          field: '@timestamp',
          interval: interval,
          min_doc_count: 0,
          offset: offset,
          time_zone: '+08:00',
          format: 'epoch_millis'
        }
      }
    }
  }

  // ------filter MessageInOut: in為方向正確
  const queryMessageInOut = {
    query_string: {
      query: '(in)',
      fields: ['Message']
    }
  }
  query.query.bool.filter.push(queryMessageInOut)

  // ------filter object Type
  const typeString = Utils.getESQueryByObjectType(objectTypes)
  if (!Utils.isEmptyString(typeString)) {
    const queryType = {
      query_string: {
        query: typeString,
        fields: ['ObjectType']
      }
    }
    query.query.bool.filter.push(queryType)
  }

  const queryResult = await elaticsearchQuery(query)
  return handleCountPerDayData(queryResult)
}

function handleCountPerDayData(ESResult) {
  if (Utils.isEmptyObject(ESResult) ||(ESResult.status < 200 && ESResult.status >= 300) ) {
    return {}
  }

  const buckets = ESResult.data.aggregations.data.buckets // [{key_as_string: '1632412800000', key: 1632412800000, doc_count: 34642}, {key_as_string: '1632499200000', key: 1632499200000, doc_count: 32198}]

  const result = buckets.reduce((obj, element) => {
    obj[element.key_as_string] = element.doc_count
    return obj
  }, {})
  return result
}

function generateWeeklyQuery(streamingIds,
  startTime,
  endTime,
  interval = '1h',
  dataType = CONST.ELK_TYPE.TYPE_VEHICLE_PLATE,
  objectTypes) {
  const queryStreamId = Utils.getStreamingId(streamingIds)
  const intervalUnit = interval.split('')[interval.length - 1]
  const intervalValue = Number(interval.replace(intervalUnit, ''))
  let offset = '+0m'
  if ((intervalValue > 1 && intervalUnit === 'm') || intervalUnit === 'h') {
    const st = moment(startTime).startOf('h')
    const diffTime = moment.duration(moment(startTime).diff(st)).as('m')
    const modNum = diffTime % intervalValue
    offset = `+${modNum}m`
    if (intervalUnit === 'h' || intervalValue > 30) {
      offset = `+${st.hours() * 60 + modNum}m`
    }
  }
  if (intervalUnit === 'd') {
    offset = '+0h'
  }

  const query = {
    query: {
      bool: {
        filter: [
          {
            range: {
              '@timestamp': {
                gte: startTime.valueOf(),
                lte: endTime.valueOf(),
                format: 'epoch_millis'
              }
            }
          },
          {
            query_string: {
              analyze_wildcard: true,
              query: queryStreamId
            }
          }
        ]
      }
    },
    size: 1,
    aggs: {
      data: {
        date_histogram: {
          field: '@timestamp',
          interval: interval,
          min_doc_count: 0,
          offset: offset,
          time_zone: '+08:00',
          format: 'epoch_millis'
        }
      }
    }
  }

  // ------filter object Type
  const typeString = Utils.getESQueryByObjectType(objectTypes)
  if (!Utils.isEmptyString(typeString)) {
    const queryType = {
      query_string: {
        query: typeString,
        fields: ['ObjectType']
      }
    }
    query.query.bool.filter.push(queryType)
  }

  return query
}

export async function getMutiWeeklyData(condition) {
  const queryTimeObjs = Utils.isEmptyObject(condition.queryTimeObjs) ? [] : condition.queryTimeObjs
  const streamingIds = Utils.isEmptyObject(condition.streamingIds) ? [] : condition.streamingIds
  const interval = Utils.isEmptyObject(condition.interval) ? '1h' : condition.interval
  const dataType = Utils.isEmptyObject(condition.dataType) ? CONST.ELK_TYPE.TYPE_VEHICLE_PLATE : condition.dataType
  const objectTypes = Utils.isEmptyObject(condition.objectTypes) ? [] : condition.objectTypes

  const querys = queryTimeObjs.map(qto => {
    return `{}\n${JSON.stringify(
      generateWeeklyQuery(streamingIds, qto.startTime, qto.endTime, interval, dataType, objectTypes)
    )}\n`
  }).join('')
  const result = await elaticsearchMutiQuery(querys)
  return handleWeeklyData(result)
}

function handleWeeklyData(ESResult) {
  if (ESResult.status < 200 && ESResult.status >= 300) {
    return []
  }

  const result = []
  // const buckets = ESResult.data.aggregations.data.buckets
  ESResult.data.responses.forEach(element => {
    const buckets = element.aggregations.data.buckets
    const data = buckets.reduce((obj, element) => {
      obj[element.key_as_string] = element.doc_count
      return obj
    }, {})

    result.push(data)
  })
  return result
}
